




















import Vue from 'vue'
import { Tab3LinkInterface } from '@/config/interfaces'
export default Vue.extend({
  name: 'Tab3LinkEl',

  props: {
    templateItemData: {
      type: Object as () => Tab3LinkInterface,
      required: true
    }
  }
})
